import { ArrowButtonDesignType } from '@typings/setting/homepageSetting.interface';
import {
  DiaArrowDesign,
  CircleArrowDesign,
  SlideArrowDesign,
  RuneArrowDesign,
  PixelArrowDesign,
  CrystalArrowDesign,
  ArrowButtonDesignProps,
} from './BackButtonDesigns';

export type { ArrowButtonDesignProps };

export const ARROW_BUTTON_DESIGNS: {
  type: ArrowButtonDesignType;
  name: string;
  component: React.FC<ArrowButtonDesignProps>;
}[] = [
    { type: 'diaArrow', name: '다이아 애로우', component: DiaArrowDesign },
    { type: 'circleArrow', name: '서클 애로우', component: CircleArrowDesign },
    { type: 'slideArrow', name: '슬라이드 애로우', component: SlideArrowDesign },
    { type: 'runeArrow', name: '룬 애로우', component: RuneArrowDesign },
    { type: 'pixelArrow', name: '픽셀 애로우', component: PixelArrowDesign },
    { type: 'crystalArrow', name: '크리스탈 애로우', component: CrystalArrowDesign },
  ];

export function getArrowButtonComponent(
  designType: ArrowButtonDesignType = 'diaArrow',
): React.FC<ArrowButtonDesignProps> {
  const found = ARROW_BUTTON_DESIGNS.find((d) => d.type === designType);
  return found ? found.component : DiaArrowDesign;
}
